import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListHeadItemLabelComponent } from '@fi-app/components/items-list/head-item/head-item-label/head-item-label.component';

@Component({
    selector: 'fi-checklist-list-head-item-colour-indicator',
    templateUrl: './head-item-colour-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChecklistLitHeadItemColourIndicator extends ItemsListHeadItemLabelComponent {}
